<template>
  <div id="wrap">
    <router-view/>
    <div id="SenchaWrap" v-if="SenchaState">
       <div class="SenchaWrapHead">
           <div class="Platform flex">
               <span>{{ platformname }}</span>
           </div>
           <div class="Logo flexbetween">
               <i><img src="./assets/Home/Logo.png"></i>
               <i><img src="./assets/Home/LogoTitle.png"></i>
           </div>
           <div class="UserNameWrap flex"><span>{{currentSystem.name}}</span></div>
           <div class="CloseSencha" @click="CloseSencha"><img src="./assets/Home/closesencha.png"></div>
       </div>
       <!-- sencha容器 -->
       <div id="GESenchaDiv" class="SenchaContentWrap Scroll">

       </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'App',
    provide() {
      return {
        load: this.load
      };
    },
    data() {
      return {
        Loading: {},
        load: {}
      };
    },
    computed: {
      ...mapGetters(['SenchaState', 'currentSystem', 'platformname'])
    },
    methods: {
      CloseSencha() {
        this.$store.dispatch('togglesenchabox', false);
      }
    },
    created() {
      // 在页面加载时读取sessionStorage里的状态信息
      if (sessionStorage.getItem('store')) {
        this.$store.replaceState(
          Object.assign(
            {},
            this.$store.state,
            JSON.parse(sessionStorage.getItem('store'))
          )
        );
      }
      // 在页面刷新时将vuex里的信息保存到sessionStorage里
      // let me = this;
      window.addEventListener('beforeunload', () => {
        // if (me.reloadStoreFlag) {
        sessionStorage.setItem('store', JSON.stringify(this.$store.state));
        // }
      });

      this.load.show = () => {
        this.Loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)'
        });
      };

      this.load.hide = () => {
        this.Loading.close();
      };
    }
  };
</script>
<style lang="scss">
    @import '../public/Value';
    .el-loading-mask {
      font-size: 40px;
    }
    #wrap * {
      box-sizing: content-box !important;
    }
    #GESenchaDiv * {
      box-sizing: border-box !important;
    }
    #SenchaWrap{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background-color: #fff;
        z-index: 10;
        .SenchaContentWrap{
            width: 100%;
            height: calc(100% - 0.35rem);
            background-color: #fff;
        }
        .CloseSencha{
            width: 0.15rem;
            position: absolute;
            right: 0.1rem;
            top: 0.1rem;
            cursor: pointer;
            img{
                width: 100%;
            }
        }
        .SenchaWrapHead{
            width: 100%;
            height: 0.35rem;
            background-color: #000;
        }
        .Platform{
            height: 0.35rem;
            position: absolute;
            left: 0.35rem;
            top: 0;
            img{
                height: 0.15rem;
            }
            span{
                font-size: $TextSize;
                color: #fff;
            }
        }
        .UserNameWrap{
            height: 0.35rem;
            position: absolute;
            right: 0.35rem;
            top: 0;
            span{
                font-size: $TextSize;
                color: #fff;
            }
        }
        .Logo{
            width: 49%;
            padding-top: 0.1rem;
            margin: 0 auto;
            i {
                height: 0.15rem;
                img {
                    height: 100%;
                }
            }
        }
    }
</style>
